import { Caption, useStyles } from '@archipro-design/aria';
import * as S from './OptionHeader.mobile.style';
import React from 'react';
import { AngleDown } from '@archipro-design/icons';

interface Props
    extends Pick<
        React.HTMLAttributes<HTMLDivElement>,
        'onClick' | 'className'
    > {
    expanded: boolean;
    title: string;
    subTitle?: React.ReactNode;
    hasManyOptions?: boolean;
}

const OptionHeader = ({
    expanded,
    title,
    subTitle,
    onClick,
    hasManyOptions = true,
    ...rest
}: Props) => {
    const { css } = useStyles({ expanded });
    return (
        <div onClick={onClick} className={css(S.OptionHeader)} {...rest}>
            <Caption className={css(S.Title)} variant="03">
                {title}
            </Caption>
            {!expanded && subTitle}
            {hasManyOptions && (
                <div className={css(S.Indicator)}>
                    <AngleDown />
                </div>
            )}
        </div>
    );
};

export default OptionHeader;
